import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from 'src/app/helpers/date/dateUtils';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(value: Date | string | null | undefined, isMobile: boolean): string | null {
    return DateUtils.format(value, isMobile);
  }
}
